import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from "@mui/material";
export function TokenAvatar({ tokenInfo, ...AvatarProps }) {
    const { sx: AvatarSx = {} } = AvatarProps ?? {};
    return tokenInfo.logoURI ? (_jsx(Avatar, { alt: `${tokenInfo.symbol} logo`, src: tokenInfo.logoURI, ...AvatarProps, sx: { width: 24, height: 24, objectFit: "contain", ...AvatarSx } })) : (_jsx(Avatar, { alt: `${tokenInfo.symbol} logo`, ...AvatarProps, sx: { width: 24, height: 24, ...AvatarSx }, children: " " }));
}
